// extracted by mini-css-extract-plugin
export default {"searchInput":"DefaultColumnFilter_searchInput__cIMio"};